import { render, staticRenderFns } from "./EhrContextStudent.vue?vue&type=template&id=95433200&scoped=true&lang=pug"
import script from "./EhrContextStudent.vue?vue&type=script&lang=js"
export * from "./EhrContextStudent.vue?vue&type=script&lang=js"
import style0 from "./EhrContextStudent.vue?vue&type=style&index=0&id=95433200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95433200",
  null
  
)

export default component.exports